import { createContext } from 'react';
import useAuthentication from 'src/store/hooks/useAuthentication';

const AuthContext = createContext({
  token: '',
  account: undefined,
  isLoggedIn: false,
  isAdmin: false,
  isSuperUser: false,
  logoutNotified: false,
  login: () => {},
  logout: () => {},
});

export const AuthProvider = (props) => {
  const {
    initialized,
    loginState,
    logoutHandler,
    loginHandler,
    clearAccessToken,
    loginBackdoorHandler,
    updateAccountHandler,
    refreshSession,
  } = useAuthentication({
    logoutEndpoint: '/account/logout',
    accessTokenEndpoint: '/account/accessToken',
  });

  const contextValue = {
    token: loginState.token,
    account: loginState.account,
    updateAccount: updateAccountHandler,
    isLoggedIn: !!loginState.token,
    logoutNotified: loginState.logoutNotified,
    login: loginHandler,
    logout: logoutHandler,
    isAdmin: loginState?.account?.isAdmin,
    // Should only be called to clear an invalid access token once the session token has expired
    clearAccessToken,
    backdoor: loginState?.backdoor,
    loginBackdoor: loginBackdoorHandler,
    remainingTime: loginState?.remainingTime,
    refreshSession,
  };
  return initialized ? (
    <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>
  ) : null;
};

export default AuthContext;
